
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getDatabase, ref, onValue } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyBrB4MxSHMvyrnh-pWHpkBpiHpoSH5gB9o",
  authDomain: "private-app-marc.firebaseapp.com",
  projectId: "private-app-marc",
  storageBucket: "private-app-marc.firebasestorage.app",
  messagingSenderId: "506776269674",
  appId: "1:506776269674:web:1bfed258984daa2432eb13",
  databaseURL: "https://private-app-marc-default-rtdb.firebaseio.com"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const storage = getStorage(app);
const database = getDatabase(app);

export { auth, storage, database };
